import { render } from "./ListForManager.vue?vue&type=template&id=267c42f2"
import script from "./ListForManager.vue?vue&type=script&lang=js"
export * from "./ListForManager.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__